export default { PACKAGE_VERSION: "0.22.0" };
